import { forwardRef } from 'react';

export const CancelIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0)">
          <path
            d="M19.0711 4.92898C15.1678 1.02575 8.83216 1.02575 4.92893 4.92898C1.0257 8.83221 1.0257 15.1679 4.92893 19.0711C8.83216 22.9743 15.1678 22.9743 19.0711 19.0711C22.9743 15.1679 22.9743 8.83221 19.0711 4.92898ZM14.8284 16.2427L12 13.4143L9.17157 16.2427L7.75736 14.8285L10.5858 12L7.75736 9.17162L9.17157 7.7574L12 10.5858L14.8284 7.7574L16.2426 9.17162L13.4142 12L16.2426 14.8285L14.8284 16.2427Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="none" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
